"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeMap = void 0;
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const clsx_1 = __importDefault(require("clsx"));
const styles = __importStar(require("./styles.css"));
const constants_1 = require("./constants");
const BaseContentNode_1 = require("./components/BaseContentNode/BaseContentNode");
const BaseTooltip_1 = require("./components/BaseTooltip/BaseTooltip");
const TreeMap = ({ data, dataKey = 'size', nameKey = 'name', width = constants_1.DEFAULT_CONTAINER_WIDTH, height = constants_1.DEFAULT_CONTAINER_HEIGHT, aspectRatio = constants_1.DEFAULT_ASPECT_RATIO, containerClassName, style, colorMainFillBlocks = constants_1.DEFAULT_COLOR_BLOCK, colorTrendDirection, colorLabel = constants_1.DEFAULT_COLOR_LABEL, stroke = constants_1.NONE, isTooltipActive = false, isAnimationActive = true, isUpdateAnimationActive, animationBeginTimeInMs, animationDuration, animationEasing, dataTestId = 'fds-tree-map-chart', Content, }) => {
    const BaseContent = (0, react_1.useCallback)((props) => Content ? (react_1.default.createElement(Content, Object.assign({}, props, { dataTestIdMain: dataTestId, colorMainFillBlocks: colorMainFillBlocks, colorTrendDirection: colorTrendDirection, colorLabel: colorLabel }))) : (react_1.default.createElement(BaseContentNode_1.BaseContentNode, Object.assign({}, props, { dataTestIdMain: dataTestId, colorMainFillBlocks: colorMainFillBlocks, colorTrendDirection: colorTrendDirection, colorLabel: colorLabel }))), [Content, colorTrendDirection, dataTestId, colorMainFillBlocks, colorLabel]);
    const TooltipContent = (0, react_1.useCallback)((props) => react_1.default.createElement(BaseTooltip_1.BaseTooltip, Object.assign({}, props, { dataTestId: `${dataTestId}-tooltip` })), [dataTestId]);
    return (react_1.default.createElement(recharts_1.Treemap, { "data-test-id": dataTestId, className: (0, clsx_1.default)(styles.container, containerClassName), style: style, data: data, dataKey: dataKey, nameKey: nameKey, stroke: stroke, width: width, height: height, content: BaseContent, aspectRatio: aspectRatio, fill: colorMainFillBlocks, isAnimationActive: isAnimationActive, isUpdateAnimationActive: isUpdateAnimationActive, animationDuration: animationDuration, animationEasing: animationEasing, animationBegin: animationBeginTimeInMs }, isTooltipActive && react_1.default.createElement(recharts_1.Tooltip, { content: TooltipContent })));
};
exports.TreeMap = TreeMap;
